import { useEffect, useState } from 'react';
import Portal from '@common/portal';
import { MILLISECONDS_PER_DAY } from '@domain/constant/Time';
import LocalStorageUtil from '@utils/storage/localStorage';
import { bodyScrollHidden } from '@utils/common';
import classnames from 'classnames/bind';
import styles from './layerModal.module.scss';
const cx = classnames.bind(styles);

const LayerModalItem = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleStop = () => {
    LocalStorageUtil.setItem('errorNotice', 'off', { expires: new Date(Date.now() + MILLISECONDS_PER_DAY) });
    setIsVisible(false);
    bodyScrollHidden(false);
  };

  useEffect(() => {
    const value = LocalStorageUtil.getItem('errorNotice');
    if (!value) {
      setIsVisible(true);
      bodyScrollHidden(true);
    }

    return () => {
      bodyScrollHidden(false);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <>
      <div className={cx('dimmed')} />
      <div className={cx('layerModal')}>
        <div className={cx('layerModalArea')}>
          <img src={'/img/errorNoticeModal/modalImg.png'} width={560} height={524} alt="modal image" />

          <div className={cx('buttonArea')}>
            <a onClick={handleStop} className={cx('button')} role="button">
              오늘은 그만 보기
            </a>
            <a
              onClick={() => {
                setIsVisible(false);
                bodyScrollHidden(false);
              }}
              className={cx('button')}
              role="button"
            >
              닫기
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

const ErrorNoticeModal = () => {
  return (
    <Portal selector="#popup">
      <LayerModalItem />
    </Portal>
  );
};

export default ErrorNoticeModal;
